module.exports = __webpack_public_path__ + "static/img/product_06.ce40fb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_06.jpg
// module id = z8wg
// module chunks = 2